import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import type { inferQueryKeyStore } from '@lukemorales/query-key-factory';
import { users } from './queries/users';
import { properties } from './queries/properties';
import { dictionaries } from './queries/dictionaries';
import {
  settings,
  services,
  portfolio as adminPortfolio,
  packages as adminPackages,
  pointsOfInterest as adminPointsOfInterest,
} from './queries/admin';
import { favorites } from './queries/favorites';
import { portfolio } from './queries/portfolio';
import { marketing } from './queries/marketing';
import { freeTier } from './queries/freeTier';
import { funnel } from './queries/funnel';
import { billing } from './queries/billing';
import { team } from './queries/team';
import { accountManager } from './queries/accountManager';
import { geo } from './queries/geo';
import { uaeIdentity } from './queries/uaeIdentity';
import { uaeJoin } from './queries/uaeJoin';
import { uaeDashboard } from './queries/uaeDashboard';
import { uaeAdmin } from './queries/uaeAdmin';
import { uae } from './queries/uae';
import { agency } from './queries/agency';
import { coBrokePayouts } from './queries/coBrokePayouts';
import { coBrokeAdmin } from './queries/coBrokeAdmin';
import { coBrokeAccess } from './queries/coBrokeAccess';
import { staffLink } from './queries/staffLink';
import { exclusiveUnits } from './queries/exclusiveUnits';
import { integrations } from './queries/integrations';
import { agentContracts } from './queries/agentContracts';
import { aaForms } from './queries/aaForms';
import { dldMarket } from './queries/dldMarket';
import { b2b } from './queries/b2b';
import { b2bClients } from './queries/b2bClients';
import { b2bDashboard } from './queries/b2bDashboard';
import { b2bDeals } from './queries/b2bDeals';
import { b2bPayouts } from './queries/b2bPayouts';
import { serviceOrders } from './queries/serviceOrders';
import { agentActivity } from './queries/agentActivity';

export const queries = mergeQueryKeys(
  users,
  properties,
  dictionaries,
  settings,
  services,
  favorites,
  portfolio,
  adminPortfolio,
  adminPackages,
  adminPointsOfInterest,
  marketing,
  freeTier,
  funnel,
  billing,
  team,
  accountManager,
  geo,
  uaeIdentity,
  uaeJoin,
  uaeDashboard,
  uaeAdmin,
  uae,
  agency,
  coBrokePayouts,
  coBrokeAdmin,
  coBrokeAccess,
  exclusiveUnits,
  integrations,
  staffLink,
  agentContracts,
  dldMarket,
  aaForms,
  b2b,
  b2bClients,
  b2bDashboard,
  b2bDeals,
  b2bPayouts,
  serviceOrders,
  agentActivity,
);

export type QueryKeys = inferQueryKeyStore<typeof queries>;
